import { render, staticRenderFns } from "./Compass.vue?vue&type=template&id=20b6654d&"
import script from "./Compass.vue?vue&type=script&lang=js&"
export * from "./Compass.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports